import { EGoalType, type Goal as GoalModel } from '@feathr/blackbox';

interface IShouldRenderArgs {
  goal: GoalModel;
}

/** Conversion value is not supported for Conversion Pixel Trigger goals. */
const VALID_CONVERSION_VALUE_GOAL_TYPES = [
  EGoalType.url_visit,
  EGoalType.custom,
  EGoalType.form_submission,
  EGoalType.donation_form_submission,
];

/** ConversionValueEntry should only render when a supported goal type is selected. */
export function shouldRender({ goal }: IShouldRenderArgs): boolean {
  const goalType = goal.get('conv_type');

  if (!goalType || !VALID_CONVERSION_VALUE_GOAL_TYPES.includes(goalType)) {
    return false;
  }

  return true;
}
